import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({ top: element.offsetTop - 64, behavior: 'smooth' });
    }
  };

  const linkStyle = {
    color: 'var(--color-text-secondary)',
    fontFamily: 'var(--font-body)',
    fontSize: '0.875rem',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    textAlign: 'left' as const,
    transition: 'color 200ms',
  };

  return (
    <footer
      style={{
        borderTop: '1px solid rgba(255,255,255,0.08)',
        background: 'rgba(255,255,255,0.02)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <img
              src="/full_logo.svg"
              alt="Blue Owl SAS"
              className="h-8 w-auto mb-4"
              style={{ filter: 'brightness(0) invert(1)', opacity: 0.85 }}
            />
            <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.875rem', fontFamily: 'var(--font-body)', lineHeight: 1.7 }}>
              {t('footer.description')}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3
              className="mb-4 text-sm font-semibold"
              style={{ color: 'var(--color-text-primary)', fontFamily: 'var(--font-display)' }}
            >
              {t('footer.navigation')}
            </h3>
            <ul className="space-y-2.5">
              {[
                { id: 'home',     label: t('nav.home') },
                { id: 'services', label: t('nav.services') },
                { id: 'projects', label: t('footer.projects') },
                { id: 'about',    label: t('nav.about') },
              ].map(({ id, label }) => (
                <li key={id}>
                  <button
                    onClick={() => scrollToSection(id)}
                    style={linkStyle}
                    onMouseEnter={e => (e.currentTarget.style.color = 'var(--color-primary)')}
                    onMouseLeave={e => (e.currentTarget.style.color = 'var(--color-text-secondary)')}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3
              className="mb-4 text-sm font-semibold"
              style={{ color: 'var(--color-text-primary)', fontFamily: 'var(--font-display)' }}
            >
              {t('footer.services')}
            </h3>
            <ul className="space-y-2.5">
              {['IoT', 'APIs', 'Mobile Apps', 'Web Apps'].map(s => (
                <li key={s} style={{ color: 'var(--color-text-secondary)', fontSize: '0.875rem', fontFamily: 'var(--font-body)' }}>
                  {s}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3
              className="mb-4 text-sm font-semibold"
              style={{ color: 'var(--color-text-primary)', fontFamily: 'var(--font-display)' }}
            >
              {t('footer.contact')}
            </h3>
            <button
              onClick={() => window.dispatchEvent(new CustomEvent('openContactChat'))}
              className="btn-primary"
            >
              {t('footer.contactUs')}
            </button>
          </div>
        </div>

        <div
          className="mt-10 pt-8 text-center"
          style={{
            borderTop: '1px solid rgba(255,255,255,0.07)',
            color: 'var(--color-text-muted)',
            fontSize: '0.8125rem',
            fontFamily: 'var(--font-body)',
          }}
        >
          &copy; {currentYear} — {t('footer.companyName')} — {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
